import { render, staticRenderFns } from "./MethodPayment.vue?vue&type=template&id=2429384a&scoped=true"
import script from "./MethodPayment.vue?vue&type=script&lang=js"
export * from "./MethodPayment.vue?vue&type=script&lang=js"
import style0 from "./MethodPayment.vue?vue&type=style&index=0&id=2429384a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2429384a",
  null
  
)

export default component.exports